import React from 'react'

import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import { A3innuvaContractsEducationLevelsFragment } from 'generated/resources/graphql'

import { WizardData } from 'modules/marketplace/lib/types'
import { EducationLevelItem } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/EducationalLevel/EducationalLevelItem'

interface EducationalLevelByLegalEntityProps {
  data: WizardData
  name: string | null | undefined
  educationLevels: A3innuvaContractsEducationLevelsFragment[]
  options: Item[]
  onSelect: (educationLevelId: string, value: string, label: string) => void
  loading: boolean
}

export const EducationalLevelByLegalEntity: React.FC<EducationalLevelByLegalEntityProps> = ({
  name,
  educationLevels,
  options,
  onSelect,
  data,
  loading,
}) => {
  const findEducationLevel = (educationLevelId: number) => {
    const selection = data.answers[`education_level_${educationLevelId}`]
    if (!selection) return ''

    return options.find((option) => option.value === selection)?.label || ''
  }

  return (
    <Box gap="s24">
      {name && <Text.Header2>{name}</Text.Header2>}
      {educationLevels.map((educationLevel) => (
        <EducationLevelItem
          key={`education_level_item_${educationLevel.id}`}
          educationLevel={educationLevel}
          selectedValue={findEducationLevel(educationLevel.id)}
          options={options}
          onSelect={(value, label) => onSelect(educationLevel.id.toString(), value, label)}
          loading={loading}
        />
      ))}
    </Box>
  )
}
